import MuiMenu, { MenuProps } from "@mui/material/Menu";

const Menu: React.FC<MenuProps> = MuiMenu;

export default Menu;
export type { MenuProps };
